import {takeEvery} from 'redux-saga/effects'
import {GET_ACTIVITIES} from 'setup/redux/Actions/Activity/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ACTIVITIES, fetchData)
}

export default dataSaga
